import storage from '@/utils/storage';

export default {
  namespaced: true,
  state: {
    darkMode: storage.get('theme') === 'dark' || false
  },
  getters: {
    isDarkMode: (state) => state.darkMode
  },
  mutations: {
    SET_DARK_MODE(state, darkMode) {
      state.darkMode = darkMode;
      storage.set('theme', darkMode ? 'dark' : 'light');
    }
  },
  actions: {
    toggleTheme({ commit, state, dispatch }) {
      commit('SET_DARK_MODE', !state.darkMode);
      dispatch('applyTheme');
    },
    applyTheme({ state }) {
      const root = document.documentElement;
      if (state.darkMode) {
        root.classList.add('dark-mode');
        root.classList.remove('light-mode');
      } else {
        root.classList.add('light-mode');
        root.classList.remove('dark-mode');
      }
    },
    initializeTheme({ dispatch }) {
      dispatch('applyTheme');
    }
  }
};